import { assertUnmatched } from '@statmuse/core/util'

export type InningSegment = 'Top' | 'Mid' | 'Bottom' | 'End'

export const getInningSegment = (
  outs: number,
  inningHalf: 'top' | 'bottom',
): InningSegment => {
  switch (inningHalf) {
    case 'top':
      return outs === 3 ? 'Mid' : 'Top'
    case 'bottom':
      return outs === 3 ? 'End' : 'Bottom'
    default:
      assertUnmatched(inningHalf)
  }
}
